import React, { Component, createRef, useState } from 'react';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import { Spinner } from 'react-bootstrap';
import { Button, Modal, Select, SelectActions, Input } from '../../../components';
import { Constants, Globals, axios } from '../../../utils';
import Menu from '../../menu';
import ModalProducts from './modal-products';
import ModalPromotedProducts from './ModalPromotedProducts';
import CreateEditClient from '../../clients/create_edit_client';

import LocationPinIcon from '../../../assets/icons/location-pin.png';
import LeftArrowIcon from '../../../assets/icons/left-arrow.png';
import CloseIcon from '../../../assets/icons/close-black.png';

const STEP = {
    PRODUCTS: 1,
    PAYMENT: 2,
}

// Modificadas para aceptar decimales dinámicos
function parse(value, decimals = 2) {
    const multiplier = Math.pow(10, decimals);
    // Se agrega un epsilon minúsculo para contrarrestar errores acumulativos de punto flotante en JS (ej. 156.13249999999996)
    return parseFloat((Math.round((parseFloat(value || 0) + 0.00000001) * multiplier) / multiplier).toFixed(decimals));
}

function getMaxLimit(product, warehouses = []) {
    if (!product) return null;

    let limited = product.limited;

    // Si el producto en el carrito no tiene "limited" (ej. cargado de draft), buscar en warehouses
    if (limited === undefined && warehouses && warehouses.length > 0) {
        for (const w of warehouses) {
            if (w.products) {
                const wProduct = w.products.find(wp => wp.product_id === product.id || wp.product?.id === product.id);
                if (wProduct && wProduct.product && wProduct.product.limited !== undefined) {
                    limited = wProduct.product.limited;
                    break;
                }
            }
        }
    }

    if (!limited) return null;

    if (Array.isArray(limited)) {
        return limited.length > 0 ? limited[0].max_quantity : null;
    }
    return limited.max_quantity;
}

function format(value, decimals = 2) {
    return parseFloat(value || 0).toFixed(decimals);
}

class NewRequest extends Component {

    state = {
        step: STEP.PRODUCTS,
        visible_products: false,
        visible_client: false,
        showPromotedProductsModal: false,
        isSubmittedForm: false,
        isLoadingWarehouses: false,
        created_client: null,
        form: {
            user: this.props.user,
            user_id: this.props.user.id,
            seller_id: this.props.user.id,
            search: '',
            client_id: '',
            status_payment: Constants.PAYMENT_TYPES.PAID,
            discount: '',
            initial_payment: '',
            credit_days: '',
            change: 0,
            comments: '',
            client: null,
            details: [],
            methods_selected: [],
            is_copy: false,
            warehouse_id: "",
            currency: Constants.CURRENCIES.DOLARES,
            general_discounts: [],
        },
        totals: {
            subtotal_usd: 0,
            subtotal_bs: 0,
            paid_usd: 0,
            paid_bs: 0,
            left_usd: 0,
            left_bs: 0,
            total_bs: 0,
            total_usd: 0,
            change_bs: 0,
            change_usd: 0,
        },
        clients: [],
        sellers: [],
        zones: [],
        methods: [],
        exchangeRate: 0,
        warehouses: [],
        formatWarehouses: [],
        clientOrdersToPay: null,
        client_categories: [],
        general_discounts: [],
        countryEquivalent: Globals.getUserCountryEquivalent(),
        IVA: Globals.getAdminIva(),
        discountsRules: null,
    }

    debounce = createRef();

    componentDidMount() {
        this.getWarehouses();
        this.getClients();
        this.getSellers();
        this.getZones();
        this.getExchangeRate();
        this.getPaymentMethods();
        this.getClientCategories();
        //this.getAdminGeneralDiscounts();
        this.getNewDiscounts();
    }

    // Helper para obtener la cantidad de decimales según config
    getDecimals = () => {
        return this.props.user?.config?.three_decimals === Constants.STATUS_ACTIVE ? 3 : 2;
    }

    resetForm = () => {
        this.setState(state => ({
            form: {
                ...state.form,
                user_id: this.props.user.id,
                seller_id: this.props.user.id,
                search: '',
                client_id: '',
                status_payment: Constants.PAYMENT_TYPES.PAID,
                discount: '',
                initial_payment: '',
                credit_days: '',
                change: 0,
                comments: '',
                client: null,
                seller: null,
                details: [],
                methods_selected: [],
                is_copy: false,
                warehouse_id: "",
                currency: Constants.CURRENCIES.DOLARES,
            },
            totals: {
                ...state.totals,
                subtotal_usd: 0,
                subtotal_bs: 0,
                paid_usd: 0,
                paid_bs: 0,
                left_usd: 0,
                left_bs: 0,
                total_bs: 0,
                total_usd: 0,
                change_bs: 0,
                change_usd: 0,
            },
        }));
    }

    getClients = async () => {
        Globals.setLoading();

        try {
            const filter = {
                user_id: this.state.form.user_id,
                search: this.state.form.search,
            };

            const res = await axios.post('web/admin/orders/clients', filter);
            if (!res.data?.clients) throw Error('No se encontraron los clientes');

            const activeClients = res.data.clients.data.filter(c => c.status === Constants.STATUS_ACTIVE);

            let clients = activeClients.map(c => ({
                ...c,
                value: c.id,
                label: !!c.document ? `${c.name} - ${this.state.countryEquivalent.businessDni} ${c.document}` : c.name,
            }));

            if (this.state.created_client) {
                clients = clients.filter(i => i.id != this.state.created_client?.id);
                clients.unshift({
                    ...this.state.created_client,
                    value: this.state.created_client.id,
                    label: !!this.state.created_client.document ? `${this.state.created_client.name} - ${this.state.countryEquivalent.businessDni} ${this.state.created_client.document}` : this.state.created_client.name,
                });
            }

            this.setState({ clients });

        } catch (error) {
            Globals.showError(error?.message);
            console.log('NewRequest -> getClients -> catch:', error)
        }

        Globals.quitLoading();
    }

    getSellers = async () => {
        Globals.setLoading();

        try {
            const filter = {
                user_id: this.state.form.user_id,
                search: this.state.form.search_seller,
            };

            const res = await axios.post('web/admin/orders/sellers', filter);
            if (!res.data?.sellers) throw Error('No se encontraron los vendedores');

            const sellers = res.data.sellers.data.map(c => ({
                ...c,
                value: c.id,
                label: !!c.document ? `${c.name} - ${this.state.countryEquivalent.businessDni} ${c.document}` : c.name,
            }));

            this.setState({ sellers });

        } catch (error) {
            Globals.showError(error?.message);
            console.log('NewRequest -> getSellers -> catch:', error)
        }

        Globals.quitLoading();
    }

    getZones = async () => {
        Globals.setLoading();

        axios
            .post("web/admin/zones", { user_id: this.props.user.id })
            .then(({ data }) => {
                data.zones.unshift({ id: "", name: "Todos" });
                this.setState({ zones: data.zones.filter(item => item.id) });
            })
            .catch(() => Globals.showError())
            .then(() => Globals.quitLoading());
    }

    getExchangeRate = async () => {
        try {
            const filter = { user_id: this.state.form.user_id };

            const res = await axios.post('admin/conversions', filter);
            if (!res.data?.conversion) throw Error('Debe establecer una tasa de cambio para continuar');

            this.setState({ exchangeRate: res.data?.conversion?.amount || 0 });

        } catch (error) {
            Globals.showError(error?.message);
            console.log('NewRequest -> getExchangeRate -> catch:', error)
        }
    }

    getPaymentMethods = async () => {
        try {
            const filter = {
                user_id: this.state.form.user_id,
            };

            const res = await axios.post('web/admin/orders/methods', filter);
            if (!res.data?.methods) throw Error('No se encontraron los métodos de pago');

            this.setState({ methods: res.data?.methods });

        } catch (error) {
            Globals.showError(error?.message);
            console.log('NewRequest -> getPaymentMethods -> catch:', error)
        }
    }

    getClientCategories = async () => {
        await axios
            .post("admin/clients/categories", { user_id: this.props.user.id, is_select: true })
            .then(({ data }) => {
                data.categories.unshift({ id: "x", name: "Sin Categoría" });
                data.categories.unshift({ id: "", name: "Todas" });

                this.setState({
                    client_categories: data.categories
                });
            })
            .catch(() => Globals.showError())
            .then(() => Globals.quitLoading());
    };

    getAdminGeneralDiscounts = async () => {
        await axios
            .post("admin/profile/generaldiscounts/get", { user_id: this.props.user.id, last_three: true })
            .then(({ data }) => {
                const initialDiscounts = data.discounts.map(d => ({
                    discount_id: d.id,
                    value: ''
                }));

                this.setState({
                    general_discounts: data.discounts,
                    form: {
                        ...this.state.form,
                        general_discounts: initialDiscounts
                    }
                });
            })
            .catch(() => Globals.showError())
            .then(() => Globals.quitLoading());
    }

    getWarehouses = async () => {
        try {
            this.setState({ isLoadingWarehouses: true });

            const data = {
                web: true,
                user_id: this.props.user.id,
                is_select: true,
                warehouse_id: this.props.user.level_id == Constants.ROLE_ADMIN ? null : this.props.user.warehouse_id,
                without_products: true,
                unique_by_size_color: true,
            };

            const res = await axios.post('web/admin/warehouses', data);
            if (res.data?.warehouses) {
                const formatWarehouses = res.data.warehouses.map(Item => ({
                    value: Item.id,
                    label: Item.name
                }));

                const mainIdx = formatWarehouses.findIndex(x => x.value === this.props.user.warehouse_principal);
                if (mainIdx >= 0) {
                    const main = formatWarehouses[mainIdx];
                    formatWarehouses.splice(mainIdx, 1);
                    formatWarehouses.unshift(main);
                }

                this.setState({
                    warehouses: res.data.warehouses,
                    formatWarehouses: formatWarehouses
                });
            }
        } catch (error) {
            Globals.showError();
            console.log('NewRequest -> getWarehouses -> catch: ', error);
        }
        this.setState({ isLoadingWarehouses: false });
    };

    change = async (value, target) => {
        await this.setState(state => ({ form: { ...state.form, [target]: value } }));

        if (target === 'currency' && Number(value) === Constants.CURRENCIES.BOLIVARES && this.state.exchangeRate <= 0) {
            Globals.showError('Debe establecer una tasa de cambio para continuar');
            this.change(Constants.CURRENCIES.DOLARES, 'currency');
        }

        if (target === 'credit_days') {
            this.setTotals();
        }

        if (target === 'status_payment') {
            if (value === Constants.PAYMENT_TYPES.PAID) {
                this.setState(state => ({
                    form: {
                        ...state.form,
                        credit_days: ''
                    }
                }));

                this.setTotals();
            } else if (value === Constants.PAYMENT_TYPES.TO_PAY) {
                const client = this.state.form.client || this.state.clients.find(c => c.id === this.state.form.client_id);
                const creditDays = client?.credit_days && Number(client.credit_days) > 0 ? client.credit_days : '';
                this.setState(state => ({
                    form: {
                        ...state.form,
                        credit_days: creditDays
                    }
                }));

                this.setTotals();
            }
        }
    }

    changeGeneralDiscount = async (discountId, value) => {
        await this.setState(state => {
            const general_discounts = [...state.form.general_discounts];
            const index = general_discounts.findIndex(d => d.discount_id === discountId);

            if (index >= 0) {
                general_discounts[index] = { ...general_discounts[index], value };
            } else {
                general_discounts.push({ discount_id: discountId, value });
            }

            return {
                form: {
                    ...state.form,
                    general_discounts
                }
            };
        });

        this.setTotals();
    }

    changeTab = (step) => {
        this.setState({ step });
    }

    goToPaymentStep = async () => {
        if (!this.state.form.client_id)
            return Globals.showError('Debe seleccionar el cliente');

        this.changeTab(STEP.PAYMENT);
    }

    goBack = (toPrevModule = false) => {
        if (this.state.step === STEP.PAYMENT && !toPrevModule)
            return this.changeTab(STEP.PRODUCTS);
        this.props.history.replace('/report-sale');
    }

    getNewDiscounts = async () => {
        Globals.setLoading();

        try {
            const response = await axios.post('admin/discounts/get', { user_id: this.props.user.id, all: true, status: Constants.STATUS_ACTIVE });

            if (response.data && response.data.discounts) {
                this.setState({ discountsRules: response.data.discounts }, () => {
                    console.log('Descuentos actualizados: ', this.state.discountsRules);
                    Globals.quitLoading();
                });
            } else {
                // Si no hay descuentos, avanzamos directamente
                Globals.quitLoading();
            }
        } catch (error) {
            console.error("Error al obtener los descuentos", error);
            Globals.quitLoading();
        }
    }

    setTotalsOLD = async () => {
        const { form, exchangeRate } = this.state;
        const decimals = this.getDecimals(); // Usar decimales configurados

        let subtotal_usd = 0;
        let subtotal_bs = 0;
        let left_usd = 0;
        let left_bs = 0;
        let total_bs = 0;
        let total_usd = 0;
        let change_bs = 0;
        let change_usd = 0;
        let totalDiscountAmount = 0;

        const products = [...form.details];
        const paid_usd = form.methods_selected.reduce((acc, curr) => acc + Number(curr.amount), 0);
        const paid_bs = parse(paid_usd * exchangeRate, decimals);

        // Calcular subtotal por productos
        for (const product of products) {
            const qty = product?.decimal_stock == Constants.DECIMAL_STOCK.YES
                ? product.quantity
                : parseInt(product.quantity);

            const subtotalWithoutDiscount = parse(qty * product.sale_price, decimals);
            const discountAmount = product.discount > 0
                ? (subtotalWithoutDiscount * product.discount) / 100
                : 0;

            product.subtotal = product.discount > 0
                ? subtotalWithoutDiscount - discountAmount
                : subtotalWithoutDiscount;

            subtotal_usd += product.subtotal;
        }

        // Aplicar descuentos sucesivos
        let currentSubtotal = subtotal_usd;
        const originalSubtotal = subtotal_usd;

        if (form.discount > 0) {
            const discountFactor = 1 - (form.discount / 100);
            currentSubtotal = currentSubtotal * discountFactor;
        }

        if (form.general_discounts && form.general_discounts.length > 0) {
            form.general_discounts.forEach(gDiscount => {
                const discountValue = parseFloat(gDiscount.value);
                if (!isNaN(discountValue) && discountValue > 0) {
                    const discountFactor = 1 - (discountValue / 100);
                    currentSubtotal = currentSubtotal * discountFactor;
                }
            });
        }

        totalDiscountAmount = originalSubtotal - currentSubtotal;
        subtotal_usd = currentSubtotal;

        subtotal_bs = parse(subtotal_usd * exchangeRate, decimals);
        total_usd = parse(subtotal_usd, decimals);
        total_bs = parse(total_usd * exchangeRate, decimals);
        left_usd = parse(subtotal_usd - paid_usd, decimals);
        left_bs = parse(left_usd * exchangeRate, decimals);

        if (left_usd < 0) {
            change_usd = parse(left_usd * -1, decimals);
            change_bs = parse(change_usd * exchangeRate, decimals);
            left_usd = parse(0, decimals);
            left_bs = parse(0, decimals);
        }

        const totalDiscountPercentage = totalDiscountAmount > 0
            ? (totalDiscountAmount / originalSubtotal) * 100
            : 0;

        await this.setState({
            form: {
                ...form,
                change: change_usd,
                details: products,
            },
            totals: {
                subtotal_usd,
                subtotal_bs,
                paid_usd,
                paid_bs,
                left_usd,
                left_bs,
                total_bs,
                total_usd,
                change_bs,
                change_usd,
                total_discount: totalDiscountAmount,
                total_discount_percentage: totalDiscountPercentage,
            }
        });
    }

    setTotals = async () => {
        const { form, exchangeRate, discountsRules } = this.state;
        const decimals = this.getDecimals();

        let subtotal_usd = 0;
        let original_subtotal_usd = 0;
        let totalDiscountAmount = 0;

        const products = [...form.details];
        const paid_usd = form.methods_selected.reduce((acc, curr) => acc + Number(curr.amount), 0);
        const paid_bs = parse(paid_usd * exchangeRate, decimals);

        const isOdooUser = this.props.user && ((this.props.user.admin ? this.props.user.admin.odoo : this.props.user.odoo) == 1);
        const checkIsBultoCajaCestaUnidad = (prod) => Globals.checkIsBultoCajaCestaUnidad(prod, isOdooUser);
        // Volumen: solo bultos/cajas/cestas (excluye "Unidad")
        const checkIsBultoCajaCesta = (prod) => Globals.checkIsBultoCajaCesta(prod, isOdooUser);

        // ---------------------------------------------------------
        // 1. RECOPILAR DESCUENTOS GLOBALES (General y Pronto Pago)
        // ---------------------------------------------------------
        let new_general_discounts = [];

        if (discountsRules && discountsRules.length > 0) {
            discountsRules.forEach(master => {
                if (master.status !== 1) return;

                // A. Descuento General (Ahora es controlado por el usuario)
                if (master.type === 'general') {
                    // Buscamos si el usuario especificó un porcentaje en el estado
                    const userDiscount = form.general_discounts.find(d => d.discount_id === master.id);
                    if (userDiscount && userDiscount.value !== '') {
                        new_general_discounts.push({
                            discount_id: master.id,
                            value: userDiscount.value
                        });
                    }
                }

                // B. Pronto Pago
                if (master.type === 'pronto_pago' && form.client && form.credit_days) {
                    const days = parseInt(form.credit_days);
                    const clientId = form.client.id || form.client.value || form.client_id;
                    if (!isNaN(days) && days > 0 && clientId) {
                        master.discount_details.forEach(rule => {
                            if (rule.client_id === clientId && days <= rule.max_days) {
                                new_general_discounts.push({ discount_id: master.id, value: parseFloat(rule.percentage) });
                            }
                        });
                    }
                }
            });
        }

        const cartProductIds = products.map(item => item.product_id || item.id);

        // ---------------------------------------------------------
        // 2. CÁLCULO LÍNEA POR LÍNEA
        // ---------------------------------------------------------
        for (const product of products) {
            const qty = product?.decimal_stock == Constants.DECIMAL_STOCK.YES ? parseFloat(product.quantity) : parseInt(product.quantity);
            const originalPrice = parseFloat(product.original_price || product.sale_price || product.price);

            let appliedPrice = originalPrice;
            let itemPercentageDiscount = 0;
            let applied_rules = []; // Seguimiento de descuentos por producto

            // Obtener el precio por defecto a comparar. Para SIZE_COLOR, buscar el de la variante específica
            let defaultPriceToCompare = product.default_price_value;
            if (product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR && product.size_colors) {
                const size_color = product.size_colors.find(i =>
                    (product.size_id && product.color_id && i.size_id === product.size_id && i.color_id === product.color_id) ||
                    (product.size_id && !product.color_id && i.size_id === product.size_id && !i.color_id) ||
                    (product.color_id && !product.size_id && i.color_id === product.color_id && !i.size_id)
                );
                if (size_color && size_color.sale_price != null) {
                    defaultPriceToCompare = size_color.sale_price;
                }
            }
            const isDefaultPrice = defaultPriceToCompare == null || parseFloat(originalPrice) === parseFloat(defaultPriceToCompare);

            // EVALUAR REGLAS POR PRODUCTO
            if (discountsRules && discountsRules.length > 0 && isDefaultPrice) {
                let allApplicableVolumenRules = [];

                discountsRules.forEach(master => {
                    if (master.status !== 1) return;

                    let rutaVendedorApplied = false;

                    master.discount_details.forEach(rule => {
                        // Límite de cantidad (PRECIO ESPECIAL)
                        if (master.type === 'limite_cantidad' && rule.product_id === (product.product_id || product.id)) {
                            if (qty <= rule.max_quantity) {
                                appliedPrice = parseFloat(rule.special_price);
                                product.special_price_applied = true;
                                product.special_price = appliedPrice;
                                product.original_special_price = appliedPrice; // precio especial real
                                product.original_price = originalPrice;        // precio normal real
                            } else if (rule.max_quantity && qty > rule.max_quantity) {
                                // Aplica el precio especial solo a la cantidad máxima, el resto usa el precio original
                                const specialQty = parseFloat(rule.max_quantity);
                                const regularQty = qty - specialQty;
                                appliedPrice = ((specialQty * parseFloat(rule.special_price)) + (regularQty * originalPrice)) / qty;
                                product.special_price_applied = true;
                                product.special_price = parse(appliedPrice, decimals);           // promedio para visualización
                                product.original_special_price = parseFloat(rule.special_price); // precio especial real
                                product.original_price = originalPrice;         // precio normal real
                                product.special_price_limit = specialQty;
                            }
                        }

                        // Por Volumen
                        if (master.type === 'volumen') {
                            if ((rule.product_id === (product.product_id || product.id) || (rule.category_id && rule.category_id === product.category_id)) && qty >= rule.min_quantity) {
                                allApplicableVolumenRules.push({ rule, master });
                            }
                        }

                        // Por Ruta / Vendedor
                        if (master.type === 'ruta_vendedor' && rule.product_id === (product.product_id || product.id) && !rutaVendedorApplied) {
                            // Si no se seleccionó vendedor explícitamente, usar el usuario logueado como fallback
                            const activeSeller = form.seller || form.user;
                            const sellerId = activeSeller ? activeSeller.id : null;
                            let isInZone = false;
                            if (rule.zone_id && activeSeller) {
                                if (activeSeller.zones && activeSeller.zones.length > 0) {
                                    isInZone = activeSeller.zones.some(z => z.id == rule.zone_id || z.zone_id == rule.zone_id);
                                } else if (activeSeller.zone_id == rule.zone_id) {
                                    isInZone = true;
                                }
                            }

                            // Aplica por zona DEL VENDEDOR seleccionado, o estrictamente por el ID del vendedor
                            if (isInZone || (rule.seller_id && rule.seller_id == sellerId)) {
                                itemPercentageDiscount += parseFloat(rule.percentage);
                                applied_rules.push({ discount_id: master.id, name: master.name, percentage: parseFloat(rule.percentage) });
                                rutaVendedorApplied = true;
                            }
                        }

                        // Por Surtido
                        if (master.type === 'surtido' && rule.product_id === (product.product_id || product.id)) {
                            let distinctCount = 0;
                            master.discount_details.forEach(surtidoRule => {
                                if (surtidoRule.counts_for_calculation && cartProductIds.includes(surtidoRule.product_id)) distinctCount++;
                            });

                            if (distinctCount >= rule.min_quantity) {
                                itemPercentageDiscount += parseFloat(rule.percentage);
                                applied_rules.push({ discount_id: master.id, name: master.name, percentage: parseFloat(rule.percentage) });
                            }
                        }
                        // Por Surtido y Volumen
                        if (master.type === 'surtido_volumen' && (rule.product_id === (product.product_id || product.id) || (rule.category_id && rule.category_id === product.category_id))) {
                            const isProductBulto = checkIsBultoCajaCestaUnidad(product);
                            if (isProductBulto) {
                                let participatingCartProdIds = [];
                                let totalBultos = 0;

                                products.forEach(cartProd => {
                                    const isCartProdBulto = checkIsBultoCajaCestaUnidad(cartProd);
                                    const isParticipating = master.discount_details.some(svRule =>
                                        (svRule.product_id === (cartProd.product_id || cartProd.id) || (svRule.category_id && svRule.category_id === cartProd.category_id))
                                        && svRule.counts_for_calculation
                                    );
                                    if (isParticipating && isCartProdBulto) {
                                        // Surtido (SKU distintos): incluye "Unidad"
                                        const actualCartProdId = cartProd.product_id || cartProd.id;
                                        if (!participatingCartProdIds.includes(actualCartProdId)) {
                                            participatingCartProdIds.push(actualCartProdId);
                                        }
                                    }
                                    if (isParticipating && checkIsBultoCajaCesta(cartProd)) {
                                        // Volumen (total bultos/cajas/cestas): NO incluye "Unidad"
                                        const qtyProd = cartProd.decimal_stock == 1 || cartProd.decimal_stock == '1' || cartProd.decimal_stock == true ? parseFloat(cartProd.quantity) : parseInt(cartProd.quantity);
                                        totalBultos += qtyProd;
                                    }
                                });

                                let distinctCount = participatingCartProdIds.length;
                                const meetsSku = distinctCount >= rule.min_sku;
                                const meetsBultos = totalBultos >= rule.min_bultos;

                                if (meetsSku && meetsBultos) {
                                    const pctOne = parseFloat(rule.percentage_one_condition);
                                    const pctBoth = parseFloat(rule.percentage_both_conditions);
                                    if (meetsSku !== meetsBultos)
                                    if (!isNaN(pctOne) && pctOne > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
                                        itemPercentageDiscount += pctOne;
                                        applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctOne });
                                    }
                                    if (!isNaN(pctBoth) && pctBoth > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
                                        itemPercentageDiscount += pctBoth;
                                        applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctBoth });
                                    }
                                } else if (meetsSku || meetsBultos) {
                                    const pctOne = parseFloat(rule.percentage_one_condition);
                                    if (!isNaN(pctOne) && pctOne > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
                                        itemPercentageDiscount += pctOne;
                                        applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctOne });
                                    }
                                }
                            }
                        }

                    });
                });

                if (allApplicableVolumenRules.length > 0) {
                    const categoryRules = allApplicableVolumenRules.filter(item => item.rule.category_id && item.rule.category_id === product.category_id);
                    const rulesToApply = categoryRules.length > 0 ? categoryRules : allApplicableVolumenRules;

                    rulesToApply.forEach(item => {
                        itemPercentageDiscount += parseFloat(item.rule.percentage);
                        applied_rules.push({ discount_id: item.master.id, name: item.master.name, percentage: parseFloat(item.rule.percentage) });
                    });
                }
            }

            if (itemPercentageDiscount > 100) itemPercentageDiscount = 100;

            // Asegurarnos de tener el manual_discount guardado la primera vez
            if (product.manual_discount === undefined) {
                product.manual_discount = Number(product.discount || 0);
            }

            // Aplicar descuentos en cascada sobre el precio aplicado
            let finalUnitPrice = appliedPrice;

            // 1. Aplicar descuento manual si existe
            if (product.manual_discount > 0) {
                let manualDesc = parseFloat(product.manual_discount);
                if (manualDesc > 100) manualDesc = 100;
                finalUnitPrice -= (finalUnitPrice * (manualDesc / 100));
            }

            // 2. Aplicar descuento automático de reglas en cascada (volumen, ruta, surtido_volumen, etc.)
            if (applied_rules.length > 0) {
                applied_rules.forEach(ar => {
                    let ruleDesc = parseFloat(ar.percentage);
                    if (!isNaN(ruleDesc) && ruleDesc > 0) {
                        if (ruleDesc > 100) ruleDesc = 100;
                        finalUnitPrice -= (finalUnitPrice * (ruleDesc / 100));
                    }
                });
            }

            if (finalUnitPrice < 0) finalUnitPrice = 0;

            product.selected_price = appliedPrice;

            // Mostrar visualmente los descuentos aplicados
            const autoDiscountStr = applied_rules.map(r => `${r.percentage}%`).join(' / ');
            if (product.manual_discount > 0 && applied_rules.length > 0) {
                product.discount = `${product.manual_discount}% / ${autoDiscountStr}`;
            } else if (product.manual_discount > 0) {
                product.discount = product.manual_discount;
            } else if (applied_rules.length > 1) {
                product.discount = autoDiscountStr;
            } else if (applied_rules.length === 1) {
                product.discount = applied_rules[0].percentage;
            } else {
                product.discount = 0;
            }

            product.applied_discounts = applied_rules;

            const lineOriginalSubtotal = qty * originalPrice;
            const lineFinalSubtotal = qty * finalUnitPrice;

            product.subtotal = parse(lineFinalSubtotal, decimals);
            original_subtotal_usd += parse(lineOriginalSubtotal, decimals);
            subtotal_usd += product.subtotal;
        }

        // ---------------------------------------------------------
        // 3. APLICAR DESCUENTOS GLOBALES AL TOTAL (CORREGIDO A CASCADA)
        // ---------------------------------------------------------
        let currentSubtotal = subtotal_usd;

        // A. Aplicar primero el form.discount (si el usuario escribió un descuento manual)
        if (form.discount > 0) {
            let desc = parseFloat(form.discount);
            if (desc > 100) desc = 100;
            currentSubtotal -= (currentSubtotal * (desc / 100));
        }

        // B. Aplicar cascada de reglas automáticas globales
        new_general_discounts.forEach(gd => {
            let desc = parseFloat(gd.value);
            if (desc > 100) desc = 100;
            // La magia de la cascada: se descuenta del "currentSubtotal" que cada vez es menor
            currentSubtotal -= (currentSubtotal * (desc / 100));
        });

        if (currentSubtotal < 0) currentSubtotal = 0;

        // Calcular el dinero total descontado (solo descuentos globales, para igualar PDF)
        totalDiscountAmount = subtotal_usd - currentSubtotal;
        // No sobreescribimos subtotal_usd con currentSubtotal para que la UI lo muestre puro (ej: 156.133)

        // ---------------------------------------------------------
        // 4. TOTALES FINALES
        // ---------------------------------------------------------
        const subtotal_bs = parse(subtotal_usd * exchangeRate, decimals);
        const total_usd = parse(currentSubtotal, decimals);
        const total_bs = parse(total_usd * exchangeRate, decimals);
        let left_usd = parse(total_usd - paid_usd, decimals);
        let left_bs = parse(left_usd * exchangeRate, decimals);
        let change_usd = 0;
        let change_bs = 0;

        if (left_usd < 0) {
            change_usd = parse(left_usd * -1, decimals);
            change_bs = parse(change_usd * exchangeRate, decimals);
            left_usd = parse(0, decimals);
            left_bs = parse(0, decimals);
        }

        const totalDiscountPercentage = totalDiscountAmount > 0 ? (totalDiscountAmount / original_subtotal_usd) * 100 : 0;

        await this.setState({
            form: {
                ...form,
                change: change_usd,
                details: products,
                general_discounts: new_general_discounts
            },
            totals: {
                subtotal_usd, subtotal_bs, paid_usd, paid_bs, left_usd, left_bs, total_bs, total_usd, change_bs, change_usd,
                total_discount: parse(totalDiscountAmount, decimals),
                total_discount_percentage: parse(totalDiscountPercentage, decimals),
            }
        });
    }

    debouncingSearchClient = async (search) => {
        if (this.debounce.current) clearTimeout(this.debounce.current);

        await this.change(undefined, 'client_id');
        await this.change(search, 'search');
        this.debounce.current = setTimeout(async () => {
            this.getClients();
        }, 1000);
    }

    debouncingSearchSeller = async (search) => {
        if (this.debounceSeller) clearTimeout(this.debounceSeller);

        await this.change(undefined, 'seller_id');
        await this.change(search, 'search_seller');
        this.debounceSeller = setTimeout(async () => {
            this.getSellers();
        }, 1000);
    }

    onSelectClient = async (id) => {
        const client = this.state.clients.find(client => client.id === id);
        await this.change(id, 'client_id');
        await this.change(client, 'client');

        if (this.state.form.status_payment === Constants.PAYMENT_TYPES.TO_PAY) {
            const creditDays = client?.credit_days && Number(client.credit_days) > 0 ? client.credit_days : '';
            await this.change(creditDays, 'credit_days');
        }

        console.log('Client: ', client);
        await this.setTotals();
    }

    onSelectSeller = async (id) => {
        const seller = this.state.sellers.find(seller => seller.id === id);
        await this.change(id, 'seller_id');
        await this.change(seller, 'seller');

        console.log('Seller: ', seller);
        // Recalcular descuentos al cambiar de vendedor (ruta_vendedor usa la zona del vendedor)
        await this.setTotals();
    }

    toggleClientModal = () => {
        this.setState(state => ({ visible_client: !state.visible_client }));
    }

    toggleProductsModal = () => {
        if (!this.state.exchangeRate)
            return Globals.showError('Debe establecer una tasa de cambio para continuar');
        this.setState(state => ({ visible_products: !state.visible_products }));
    }

    addProduct = async (product, warehouse_id) => {
        this.setState(state => ({
            form: {
                ...state.form,
                warehouse_id: warehouse_id,
            }
        }));

        let productIndex;
        let products = Globals.copy(this.state.form.details);

        productIndex = product.type === Constants.PRODUCTS_TYPE.SIZE_COLOR
            ? products.findIndex(p => p.id === product.id && p.size_id === product.size_id && p.color_id === product.color_id)
            : products.findIndex(p => p.id === product.id);

        if (productIndex >= 0) {
            const newQuantity = products[productIndex].quantity + product.quantity;
            if (newQuantity > products[productIndex].stock)
                return Globals.showError(`No hay suficiente stock (${products[productIndex].stock} disponibles)`)

            const maxLimit = getMaxLimit(products[productIndex], this.state.warehouses);
            if (maxLimit && Number(newQuantity) > Number(maxLimit))
                return Globals.showError(`El admin ha definido un máximo de ${maxLimit} unidades por pedido para este producto`);

            products[productIndex].quantity = newQuantity;
            products[productIndex].subtotal += product.subtotal;

        } else {
            const maxLimit = getMaxLimit(product, this.state.warehouses);
            if (maxLimit && Number(product.quantity) > Number(maxLimit))
                return Globals.showError(`El admin ha definido un máximo de ${maxLimit} unidades por pedido para este producto`);

            products = [...products, product];
        }

        await this.change(products, 'details');
        await this.setTotals();
    }

    removeProduct = async (index) => {
        let products = this.state.form.details.filter((_, idx) => idx !== index);
        await this.change(products, 'details');
        await this.setTotals();
    }

    oneMoreProduct = async (index) => {
        const products = Globals.copy(this.state.form.details);
        const product = products[index]
        let qty = Number(products[index].quantity)
        let newQuantity = qty + 1
        if (product.decimal_stock == Constants.DECIMAL_STOCK.YES) {
            newQuantity = parseFloat(qty + 1).toFixed(2)
        }

        const stockToValidate = products[index].total_quantity !== undefined ? products[index].total_quantity : products[index].stock;

        if (Number(newQuantity) > Number(stockToValidate))
            return Globals.showError(`No hay suficiente stock de ${products[index].name}`);

        const maxLimit = getMaxLimit(products[index], this.state.warehouses);
        if (maxLimit && Number(newQuantity) > Number(maxLimit))
            return Globals.showError(`El admin ha definido un máximo de ${maxLimit} unidades por pedido para este producto`);

        products[index].quantity = newQuantity;
        await this.change(products, 'details');
        this.setTotals();
    }

    oneLessProduct = async (index) => {
        const products = Globals.copy(this.state.form.details);
        const product = products[index]
        let qty = Number(products[index].quantity)
        let newQuantity = qty - 1
        if (product.decimal_stock == Constants.DECIMAL_STOCK.YES) {
            newQuantity = parseFloat(qty - 1).toFixed(2)
        }

        if (newQuantity < 1) return;

        const stockToValidate = products[index].total_quantity !== undefined ? products[index].total_quantity : products[index].stock;

        if (Number(newQuantity) > Number(stockToValidate)) {
            newQuantity = stockToValidate;
            Globals.showError(`No hay suficiente stock de ${products[index].name}`);
        }

        products[index].quantity = newQuantity;
        await this.change(products, 'details');
        this.setTotals();
    }

    changeManual = async (index, quantity) => {
        const products = Globals.copy(this.state.form.details);
        let newQuantity = quantity;

        if (products[index]?.decimal_stock === Constants.DECIMAL_STOCK.NO) {
            newQuantity = newQuantity === '' ? newQuantity : parseInt(newQuantity);
        } else {
            newQuantity = newQuantity.replace(/,/g, '.');
        }

        const maxLimit = getMaxLimit(products[index], this.state.warehouses);
        if (maxLimit && Number(newQuantity) > Number(maxLimit)) {
            Globals.showError(`El admin ha definido un máximo de ${maxLimit} unidades por pedido para este producto`);
            newQuantity = maxLimit;
        }

        products[index].quantity = newQuantity;
        await this.change(products, 'details');
        this.setTotals();
    }

    addPaymentMethod = (id) => {
        const method = this.state.methods.find(m => m.id === id);
        const isLocalCurrency = Constants.LOCAL_CURRENCIES.includes(method.id);
        const newMethod = {
            id,
            isLocalCurrency,
            amount: '',
            amount_bs: '',
            name: method.name,
        };

        this.setState(state => ({
            form: {
                ...state.form,
                methods_selected: [
                    ...state.form.methods_selected,
                    newMethod,
                ]
            }
        }));
    }

    changePaymentAmount = async (index, amount, isLocalCurrency = false) => {
        const payments = Globals.copy(this.state.form.methods_selected);
        const decimals = this.getDecimals();

        if (isLocalCurrency) {
            payments[index].amount = parse(parse(amount || 0, decimals) / this.state.exchangeRate, decimals);
            payments[index].amount_bs = amount;
        } else {
            payments[index].amount = amount;
            payments[index].amount_bs = parse(parse(amount || 0, decimals) * this.state.exchangeRate, decimals);
        }

        await this.setState(state => ({
            form: {
                ...state.form,
                methods_selected: payments,
            }
        }));
        this.setTotals();
    }

    removePaymentMethod = async (index) => {
        const methods_selected = this.state.form.methods_selected.filter((_, idx) => idx !== index);

        await this.setState(state => ({
            form: {
                ...state.form,
                methods_selected,
            }
        }));
        this.setTotals();
    }

    isValidForm = () => {
        const onError = (msg) => {
            this.setState({ isSubmittedForm: false });
            Globals.showError(msg);
            return false;
        }

        this.setState({ isSubmittedForm: true });
        const { form, totals } = this.state;
        const decimals = this.getDecimals();

        if (
            form.details.some(
                (i) =>
                    (!i.quantity || i.quantity < 1) && i.decimal_stock == Constants.DECIMAL_STOCK.NO
            )
        ) {
            return onError("Debe seleccionar la cantidad de todos los productos");
        }

        if (form.details.some(i => !i.sale_price))
            return onError('Debe seleccionar el precio de todos los productos');

        if (form.methods_selected.some(i => i.amount <= 0))
            return onError('Debe ingresar el monto de cada método de pago');

        if (form.status_payment === Constants.PAYMENT_TYPES.TO_PAY) {
            if (form.credit_days <= 0)
                return onError('Debe ingresar los días de crédito');

            if (parse(form.initial_payment, decimals) >= totals.total_usd)
                return onError('El pago inicial no puede ser igual o mayor al monto total. Este es un pedido por cobrar');

            if (parse(form.initial_payment, decimals) > 0 && !form.methods_selected.length)
                return onError('Debe seleccionar al menos 1 método de pago');

            if (totals.paid_usd > 0 && totals.paid_usd !== parse(form.initial_payment, decimals))
                return onError('La suma de los métodos de pago debe ser igual al pago inicial');

            if (!form.credit_days) {
                return onError('Debe indicar la cantidad de días de crédito');
            }

        } else {
            const tolerance = 0.0001;

            if (Math.abs(totals.paid_usd - totals.total_usd) > tolerance) {
                console.log('totals.paid_usd: ', totals.paid_usd);
                console.log('totals.total_usd: ', totals.total_usd);
                return onError('La suma de los métodos de pago debe ser igual al total');
            }
        }

        if (form.discount !== '' && form.discount < 0)
            return onError('El porcentaje de descuento general no puede ser negativo');

        if (form.discount !== '' && form.discount > 100)
            return onError('El porcentaje de descuento general no puede ser mayor a 100%');

        return true;
    }

    submit = async () => {
        if (!this.isValidForm()) return;

        const { form, totals } = this.state;

        // Expandir ítems con "Descuento Límite por cantidad" en dos líneas:
        // - Línea 1: cantidad con precio especial (special_price_limit unidades)
        // - Línea 2: cantidad restante con precio original
        // El total de ambas líneas es idéntico al subtotal calculado con precio promedio.
        const expandedDetails = [];
        for (const item of form.details) {
            if (
                item.special_price_applied &&
                item.special_price_limit != null &&
                item.special_price_limit > 0
            ) {
                const decimals = this.getDecimals();
                const qty = item.decimal_stock == Constants.DECIMAL_STOCK.YES
                    ? parseFloat(item.quantity)
                    : parseInt(item.quantity);
                const specialQty = parseFloat(item.special_price_limit);
                const regularQty = qty - specialQty;

                const originalPrice = parseFloat(item.original_price || item.sale_price || item.price);
                const specialPrice = parseFloat(item.original_special_price || item.special_price_limit_price || 0) || null;

                // Fila 1: unidades al precio especial
                expandedDetails.push({
                    ...item,
                    quantity: specialQty,
                    selected_price: specialPrice || item.selected_price,
                    sale_price: specialPrice || item.sale_price,
                    subtotal: parseFloat((specialQty * (specialPrice || item.selected_price)).toFixed(decimals)),
                    special_price_applied: true,
                    special_price_limit: null, // ya expandido, no repetir
                });

                // Fila 2: unidades al precio normal (solo si queda cantidad restante)
                if (regularQty > 0) {
                    expandedDetails.push({
                        ...item,
                        quantity: regularQty,
                        selected_price: originalPrice,
                        sale_price: originalPrice,
                        subtotal: parseFloat((regularQty * originalPrice).toFixed(decimals)),
                        special_price_applied: false,
                        special_price_limit: null, // ya expandido
                    });
                }
            } else {
                expandedDetails.push(item);
            }
        }

        const data = {
            ...form,
            currency: Number(form.currency),
            details: JSON.stringify(expandedDetails),
            methods_selected: JSON.stringify(form.methods_selected),
            initial_payment: form.status_payment === Constants.PAYMENT_TYPES.PAID ? null : form.initial_payment,
            credit_days: form.status_payment === Constants.PAYMENT_TYPES.PAID ? null : parseInt(form.credit_days),
            discount: form.discount || 0,
            total: totals.total_usd,
        };

        try {
            const res = await axios.post('web/admin/orders/store', data);

            if (res.data?.result == false) {
                Globals.showError(res.data?.error ?? 'El cliente ya ha alcanzado su limite de crédito permitido');
            }

            if (res.data?.url) {
                Globals.showSuccess('Se ha creado su pedido correctamente');
                this.openPrintable(res.data.url);
                if (res.data?.url_copy !== '') this.openPrintable(res.data.url_copy);
            }
            else if (res.data?.print_note_fiscal) {
                Globals.showSuccess('Se ha creado su pedido correctamente. Espere la nota de entrega');
                const order_id = res.data?.print_note_fiscal
                const res_fiscal = await axios.post('admin/orders/no-fiscal-bill', { user_id: this.props.user.id, order_id: order_id });
                if (res_fiscal.data?.result) {
                    Globals.showSuccess('Nota de entrega en proceso...');
                }
                else {
                    Globals.showError('Ocurrió un problema al imprimir la nota de entrega');
                }
            }
            this.resetForm();
            this.goBack();

        } catch (error) {
            if (error.response.data.error) {
                Globals.showError(error.response.data.error);
            }
            else {
                Globals.showError(error);
            }
            console.log('NewRequest -> submit -> catch:', error)
        }

        this.setState({ isSubmittedForm: false });
    }

    openPrintable = (url) => {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.click();
    }

    checkedChange = (newValue) => {
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                is_copy: newValue
            }
        }));
    }

    render() {

        const { form, clients, methods, sellers, isSubmittedForm, step, totals, visible_client, visible_products, zones, clientOrdersToPay, isLoadingWarehouses, client_categories, } = this.state;
        const decimals = this.getDecimals(); // Obtener decimales para renderizado

        const total_client_to_pay = clientOrdersToPay?.to_pay_orders?.reduce((accumulator, item) => accumulator + item.to_pay, 0);

        const filteredPaymentMethods = methods.filter(m => {
            return !this.state.form.methods_selected.some(ms => ms.id === m.id);
        });

        const warehouse_principal = this.props.user.warehouse_principal

        const filtered_clientCategories = client_categories.filter(Item => {
            return Item.id && Item.id > 0;
        });

        const appliedAutomaticDiscounts = [];

        form.details.forEach(item => {
            if (item.applied_discounts && item.applied_discounts.length > 0) {
                item.applied_discounts.forEach(ad => {
                    const existing = appliedAutomaticDiscounts.find(d => d.name === ad.name && d.percentage === ad.percentage);
                    if (!existing) {
                        appliedAutomaticDiscounts.push({
                            name: ad.name,
                            percentage: ad.percentage,
                            icon: 'fa-cube'
                        });
                    }
                });
            }
            if (item.special_price_applied) {
                const existing = appliedAutomaticDiscounts.find(d => d.name === 'Precio Especial');
                if (!existing) {
                    appliedAutomaticDiscounts.push({
                        name: 'Precio Especial',
                        percentage: 'Especial',
                        icon: 'fa-tag'
                    });
                }
            }
        });

        if (form.general_discounts && form.general_discounts.length > 0) {
            form.general_discounts.forEach(gd => {
                const ruleInfo = this.state.discountsRules.find(r => r.id === gd.discount_id);
                if (ruleInfo && ruleInfo.type !== 'general') {
                    appliedAutomaticDiscounts.push({
                        name: ruleInfo.name,
                        percentage: gd.value,
                        icon: 'fa-clock-o'
                    });
                }
            });
        }

        if (step === STEP.PAYMENT) return (
            <Menu
                history={this.props.history}
                leftSlot={<BackButton onClick={() => this.goBack()} />}
            >
                <div id="report-sale-create">
                    <main>
                        <section className="payment">
                            <section className="payment-type">
                                <Button
                                    block
                                    color={form.status_payment === Constants.PAYMENT_TYPES.PAID ? ' ' : 'white'}
                                    onClick={() => this.change(Constants.PAYMENT_TYPES.PAID, 'status_payment')}
                                >
                                    PAGADO
                                </Button>

                                <Button
                                    block
                                    color={form.status_payment === Constants.PAYMENT_TYPES.TO_PAY ? ' ' : 'white'}
                                    onClick={() => this.change(Constants.PAYMENT_TYPES.TO_PAY, 'status_payment')}
                                >
                                    POR PAGAR
                                </Button>
                            </section>

                            <section className="inputs">
                                <div className="form-group">
                                    <div className="multidiscount">
                                        {/* Descuento Principal */}
                                        <div>
                                            <label className="material">Descuento (%)</label>
                                            <input
                                                type="text"
                                                value={form.discount}
                                                className="form-control material"
                                                placeholder="Opcional"
                                                onChange={async (e) => {
                                                    let val = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
                                                    if ((val.match(/\./g) || []).length > 1) {
                                                        val = val.substring(0, val.length - 1);
                                                    }
                                                    await this.change(val, 'discount');
                                                    this.setTotals();
                                                }}
                                            />
                                        </div>

                                        {this.state.discountsRules && this.state.discountsRules
                                            .filter(master => master.type === 'general' && master.status === 1)
                                            .map((discount) => {
                                                const currentDiscount = form.general_discounts.find(d => d.discount_id === discount.id);
                                                const currentValue = currentDiscount ? currentDiscount.value : '';

                                                return (
                                                    <div key={`general-discount-input-${discount.id}`}>
                                                        <label htmlFor={`discount-input-${discount.id}`} className="material" style={{ whiteSpace: 'nowrap' }}>
                                                            {discount.name} %
                                                        </label>
                                                        <NumberFormat
                                                            id={`discount-input-${discount.id}`}
                                                            className="form-control material"
                                                            value={currentValue}
                                                            placeholder="opcional"
                                                            allowNegative={false}
                                                            isAllowed={(values) => {
                                                                const { floatValue } = values;
                                                                return floatValue === undefined || floatValue <= 100;
                                                            }}
                                                            onValueChange={(values) => {
                                                                this.changeGeneralDiscount(discount.id, values.value);
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>

                                    {appliedAutomaticDiscounts.length > 0 && (
                                        <div className="applied-discounts-wrapper mt-3 mb-3" style={{ border: '2px solid #2874A6', borderRadius: '4px', padding: '10px', backgroundColor: '#eef2f7', width: '100%' }}>
                                            <label className="font-weight-bold mb-2" style={{ color: '#00204a', display: 'block', fontSize: '14px' }}>
                                                Descuentos añadidos
                                            </label>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                                {appliedAutomaticDiscounts.map((ad, idx) => (
                                                    <div key={`auto-discount-${idx}`} style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#e2e9f3', color: '#333', padding: '4px 6px', borderRadius: '4px', fontSize: '13px', fontWeight: '600' }}>
                                                        <i className={`fa ${ad.icon} mr-2`} style={{ color: '#6c757d' }}></i>
                                                        <span style={{ marginRight: '8px' }}>{ad.name}</span>
                                                        {ad.percentage !== 'Especial' ? (
                                                            <span style={{ backgroundColor: '#2874A6', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>
                                                                {ad.percentage}%
                                                            </span>
                                                        ) : (
                                                            <span style={{ backgroundColor: '#198754', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>
                                                                {ad.percentage}
                                                            </span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                </div>

                                {form.status_payment === Constants.PAYMENT_TYPES.TO_PAY && (
                                    <>
                                        <div className="form-group">
                                            <label className="material">Pago inicial</label>
                                            <NumberFormat
                                                value={form.initial_payment}
                                                className="form-control material"
                                                placeholder="Opcional"
                                                allowNegative={false}
                                                decimalScale={decimals} // Aplica decimales dinámicos
                                                onValueChange={v => this.change(v.value, 'initial_payment')}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label className="material">Días de crédito</label>
                                            <NumberFormat
                                                value={form.credit_days}
                                                className="form-control material"
                                                allowNegative={false}
                                                decimalScale={0}
                                                onValueChange={v => this.change(v.value, 'credit_days')}
                                            />
                                        </div>
                                    </>
                                )}
                            </section>

                            <div className="tables">
                                <section className="table-wrapper payment-methods">
                                    <table>
                                        <thead className="bg-dark">
                                            <tr>
                                                <th>Moneda</th>
                                                <th>Monto $</th>
                                                <th>Monto {Globals.getLocalCurrencySymbol(this.props.user)}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {form.methods_selected.map((item, index) => (
                                                <PaymentItem
                                                    key={`payment-${index}`}
                                                    item={item}
                                                    decimals={decimals} // Pasar decimales
                                                    onChange={(value, isLocalCurrency = false) => this.changePaymentAmount(index, value, isLocalCurrency)}
                                                    onRemove={() => this.removePaymentMethod(index)}
                                                />
                                            ))}

                                            <tr>
                                                <td colSpan={6}>
                                                    <Select
                                                        value=""
                                                        caret
                                                        options={filteredPaymentMethods.map(m => ({ value: m.id, label: m.name }))}
                                                        onChange={e => this.addPaymentMethod(Number(e.target.value))}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </section>

                                <div>
                                    <Button className="btn-dark" onClick={() => this.changeTab(STEP.PRODUCTS)}>
                                        REGRESAR
                                    </Button>
                                </div>
                            </div>
                        </section>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Totals
                                totals={totals}
                                isPaymentStep
                                isSubmittedForm={isSubmittedForm}
                                form={form}
                                decimals={decimals} // Pasar decimales
                                onChange={(value, target) => this.change(value, target)}
                                onSubmit={() => this.submit()}
                            />
                            <div className="export-option" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '8rem' }}>
                                <input
                                    id="photo-check"
                                    type="checkbox"
                                    checked={this.state.form.is_copy}
                                    style={{ marginRight: '0.5rem' }}
                                    onChange={() => this.checkedChange(!this.state.form.is_copy)}
                                />
                                <label className="" htmlFor="photo-check" style={{ fontSize: 16, marginBottom: 0 }}>
                                    Imprimir copia
                                </label>
                            </div>
                        </div>
                    </main>
                </div>
            </Menu>
        );

        return (
            <Menu
                history={this.props.history}
                leftSlot={<BackButton onClick={() => this.goBack()} />}
            >
                <Modal
                    className="modal-report-sale-products"
                    title="Productos"
                    onClose={this.toggleProductsModal}
                    visible={visible_products}
                >
                    <ModalProducts
                        onSelectProduct={this.addProduct}
                        onClose={this.toggleProductsModal}
                        warehouses={this.state.warehouses}
                        formatWarehouses={this.state.formatWarehouses}
                    />
                </Modal>

                <ModalPromotedProducts
                    show={this.state.showPromotedProductsModal}
                    onHide={() => this.setState({ showPromotedProductsModal: false })}
                    user={this.props.user}
                    defaultWarehouseId={this.state.form.warehouse_id}
                    warehouses={this.state.warehouses}
                    formatWarehouses={this.state.formatWarehouses}
                    onSelectProduct={(product, selectedWarehouseId) => {
                        this.addProduct(product, selectedWarehouseId);
                    }}
                />

                <Modal
                    size="lg"
                    className="modal-report-sale-client"
                    title="Registrar cliente"
                    onClose={this.toggleClientModal}
                    visible={visible_client}
                >
                    <CreateEditClient
                        user={this.props.user}
                        createFromPOS={true}
                        zones={zones}
                        onSuccess={client => this.setState({ created_client: client })}
                        onClose={(reload = false) => {
                            if (reload) this.getClients();
                            this.toggleClientModal();
                        }}
                        client_categories={filtered_clientCategories}
                        sellers={sellers}
                    />
                </Modal>

                <Modal
                    className="modal-report-sale-client"
                    title="CUENTAS PENDIENTES CLIENTE"
                    onClose={() => this.setState({ clientOrdersToPay: null })}
                    visible={clientOrdersToPay}
                >
                    <p>Cliente: <b>{clientOrdersToPay?.name}</b></p>
                    <table border={1} style={{ border: 'collapse', width: '100%' }}>
                        <thead>
                            <tr style={{ textAlign: 'center' }}>
                                <th>Cuenta</th>
                                <th>Fecha</th>
                                <th>Monto</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientOrdersToPay?.to_pay_orders?.map((item, index) => (
                                <tr key={index} style={{ textAlign: 'right' }}>
                                    <td style={{ textAlign: 'center' }}>{item?.number_format}</td>
                                    <td style={{ textAlign: 'center' }}> {item?.created_es} </td>
                                    <td style={{ textAlign: 'right' }}>${Globals.formatMiles(item?.to_pay)}</td>
                                </tr>
                            ))}
                            <tr style={{ textAlign: 'right' }}>
                                <td colSpan={2}>
                                    <b>Total ctas. por cobrar:</b>
                                </td>
                                <td>
                                    <b>$ {Globals.formatMiles(total_client_to_pay)}</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Modal>

                <div id="report-sale-create">
                    <div className="filters-row">
                        <section className="filters">
                            <div className="row">
                                <div className="col-4">
                                    <SelectActions
                                        label="Nombre del cliente"
                                        placeholder={`Nombre del Cliente o ${this.state.countryEquivalent.businessDni}`}
                                        isSearchable
                                        actionOptions={[
                                            {
                                                onClick: () => this.toggleClientModal(),
                                                content: (
                                                    <div style={{ color: '#3A7FC2' }}>
                                                        <span>Registrar nuevo cliente</span>
                                                        <i className="fa fa-regular fa-plus" style={{ marginLeft: '0.75rem' }} />
                                                    </div>
                                                ),
                                            }
                                        ]}
                                        options={clients.map(i => ({
                                            value: i.id,
                                            label: i.label,
                                            actions: [],
                                        }))}
                                        value={form.client_id}
                                        onChange={this.onSelectClient}
                                        onInputChange={this.debouncingSearchClient}
                                    />
                                </div>

                                <div className="col-4">
                                    <SelectActions
                                        label="Vendedor (Opcional)"
                                        placeholder="Nombre del Vendedor"
                                        isSearchable
                                        options={sellers.map(i => ({
                                            value: i.id,
                                            label: i.name,
                                            actions: [],
                                        }))}
                                        value={form.seller_id}
                                        onChange={this.onSelectSeller}
                                        onInputChange={this.debouncingSearchSeller}
                                    />
                                </div>
                            </div>

                            <div>
                                {form.client_id && (
                                    <div className="client-address">
                                        <img src={LocationPinIcon} alt="Dirección del cliente" />
                                        <p>{form.client?.address}</p>
                                    </div>
                                )}
                            </div>

                            <div>
                                {(form.client_id && form.client?.to_pay_orders?.length > 0) && (
                                    <div className="client-address">
                                        <p style={{ color: 'red' }}>{"Cliente posee cuenta por cobrar pendiente,"}</p>
                                        &nbsp;
                                        <span
                                            style={{ color: 'red' }}
                                            className="clickable"
                                            onClick={() => this.setState({ clientOrdersToPay: form.client })}
                                        >
                                            {"ver detalles"}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </section>

                        <Totals
                            totals={totals}
                            form={form}
                            decimals={decimals} // Pasar decimales
                        />
                    </div>

                    <section className="table-wrapper">
                        <div className="table-header">
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <Button onClick={() => this.toggleProductsModal()} disabled={isLoadingWarehouses}>
                                    <div className="loader-wrapper">
                                        {isLoadingWarehouses && <div class="loader" />}
                                        <span>AGREGAR PRODUCTO</span>
                                    </div>
                                </Button>

                                <Button style={{ backgroundColor: '#1b2a47' }} onClick={() => this.setState({ showPromotedProductsModal: true })}>
                                    PRODUCTOS A PROMOVER
                                </Button>
                            </div>

                            {!!form.details.length && (
                                <Button color="green" onClick={() => this.goToPaymentStep()}>
                                    SIGUIENTE
                                </Button>
                            )}
                        </div>
                        {(() => {
                            const hasAnyDiscount = form.details.some(item =>
                                (item.manual_discount > 0) ||
                                (item.applied_discounts && item.applied_discounts.length > 0)
                            );

                            return (
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Código</th>
                                            <th>Descripción</th>
                                            <th>Stock</th>
                                            <th>Cantidad{'\n'}solicitada</th>
                                            <th>Precio</th>
                                            <th>Descuento (%)</th>
                                            {hasAnyDiscount && <th>Tipo de descuento</th>}
                                            <th>Subtotal</th>
                                            <th className="actions"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {form.details.map((item, index) => {
                                            const hasLimit = item.special_price_applied && item.special_price_limit != null && item.special_price_limit > 0;
                                            const qty = item.decimal_stock == Constants.DECIMAL_STOCK.YES
                                                ? parseFloat(item.quantity)
                                                : parseInt(item.quantity);
                                            const specialQty = hasLimit ? parseFloat(item.special_price_limit) : null;
                                            const regularQty = hasLimit ? (qty - specialQty) : null;
                                            const origPrice = hasLimit ? parseFloat(item.original_price || item.sale_price) : null;
                                            const specPrice = hasLimit ? parseFloat(item.original_special_price || item.special_price) : null;

                                            // Calcular factor de descuento para mostrar subtotales netos
                                            const manualDesc = item.manual_discount > 0 ? (parseFloat(item.manual_discount) > 100 ? 100 : parseFloat(item.manual_discount)) : 0;
                                            let discountFactor = 1;
                                            if (manualDesc > 0) discountFactor *= (1 - manualDesc / 100);
                                            if (item.applied_discounts && item.applied_discounts.length > 0) {
                                                item.applied_discounts.forEach(d => {
                                                    const pct = parseFloat(d.percentage);
                                                    if (!isNaN(pct) && pct > 0) {
                                                        discountFactor *= (1 - (pct > 100 ? 100 : pct) / 100);
                                                    }
                                                });
                                            }

                                            const netSpecPrice = hasLimit ? specPrice * discountFactor : 0;
                                            const netOrigPrice = hasLimit ? origPrice * discountFactor : 0;

                                            const colCount = 7 + (hasAnyDiscount ? 1 : 0);

                                            // Fila principal (siempre existe)
                                            const mainRow = (
                                                <tr key={`${index}-main`}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.code}</td>
                                                    <td>{item.name}</td>
                                                    <td>
                                                        {item.warehouse_id == warehouse_principal
                                                            ? item.stock
                                                            : item.total_quantity ? item.total_quantity : item.stock}
                                                    </td>
                                                    <td className="quantity">
                                                        <Button small onClick={() => this.oneLessProduct(index)}>
                                                            <i className="fa fa-minus" />
                                                        </Button>
                                                        <input
                                                            value={item.quantity}
                                                            onChange={(e) => {
                                                                if (item?.decimal_stock === Constants.DECIMAL_STOCK.NO) {
                                                                    if (Globals.validateInteger(e.target.value) || e.target.value === '') {
                                                                        if (Number(e.target.value) > item.stock) return;
                                                                        this.changeManual(index, e.target.value);
                                                                    }
                                                                } else {
                                                                    if (Number(e.target.value) > item.stock) return;
                                                                    this.changeManual(index, e.target.value);
                                                                }
                                                            }}
                                                            onBlur={(e) => {
                                                                if (e.target.value === '') this.changeManual(index, '0');
                                                            }}
                                                        />
                                                        <Button small onClick={() => this.oneMoreProduct(index)}>
                                                            <i className="fa fa-plus" />
                                                        </Button>
                                                    </td>
                                                    <td>
                                                        {hasLimit ? (
                                                            // Precio especial para la fila de cantidad especial
                                                            <span className="text-success font-weight-bold" title="Precio especial (Límite por cantidad)" style={{ cursor: 'help', borderBottom: '1px dotted #28a745' }}>
                                                                {Globals.newFormatMiles(specPrice, decimals)}
                                                                <small style={{ display: 'block', color: '#999', fontWeight: 'normal', fontSize: '0.8em' }}>
                                                                    x{specialQty} ud.
                                                                </small>
                                                            </span>
                                                        ) : item.special_price_applied ? (
                                                            <span className="text-success font-weight-bold" title="Precio especial aplicado" style={{ cursor: 'help', borderBottom: '1px dotted #28a745' }}>
                                                                {Globals.newFormatMiles(item.special_price, decimals)}
                                                            </span>
                                                        ) : (
                                                            <span className="text-dark">{Globals.newFormatMiles(item.sale_price, decimals)}</span>
                                                        )}
                                                    </td>
                                                    <td>{item.discount || '--'}</td>
                                                    {hasAnyDiscount && (
                                                        <td style={{ fontSize: '0.85em', color: '#555' }}>
                                                            {(() => {
                                                                let names = [];
                                                                if (item.manual_discount > 0) names.push('Manual');
                                                                if (item.applied_discounts && item.applied_discounts.length > 0) {
                                                                    names = names.concat(item.applied_discounts.map(d => d.name));
                                                                }
                                                                return names.length > 0 ? names.join(' + ') : '--';
                                                            })()}
                                                        </td>
                                                    )}
                                                    <td>
                                                        {hasLimit
                                                            ? Globals.formatMiles(parseFloat(netSpecPrice * specialQty).toFixed(decimals))
                                                            : Globals.formatMiles(parseFloat(item.subtotal).toFixed(decimals))
                                                        }
                                                    </td>
                                                    <td>
                                                        <img src={CloseIcon} className="btn-remove" title="Remover producto" alt="Remover producto" onClick={() => this.removeProduct(index)} />
                                                    </td>
                                                </tr>
                                            );

                                            // Fila extra (precio normal, solo cuando hay split de cantidad)
                                            const extraRow = hasLimit && regularQty > 0 ? (
                                                <tr key={`${index}-extra`} style={{ backgroundColor: '#f9f9f9' }}>
                                                    <td style={{ color: '#999' }}></td>
                                                    <td style={{ color: '#999' }}>{item.code}</td>
                                                    <td style={{ color: '#999' }}>{item.name}</td>
                                                    <td></td>
                                                    <td style={{ textAlign: 'center', color: '#555' }}>
                                                        <span>{regularQty}</span>
                                                        <small style={{ display: 'block', color: '#aaa', fontSize: '0.8em' }}>uds. precio normal</small>
                                                    </td>
                                                    <td>
                                                        <span className="text-dark" style={{ color: '#555' }}>
                                                            {Globals.newFormatMiles(origPrice, decimals)}
                                                            <small style={{ display: 'block', color: '#999', fontSize: '0.8em' }}>Precio normal</small>
                                                        </span>
                                                    </td>
                                                    <td style={{ color: '#999' }}>{item.discount || '--'}</td>
                                                    {hasAnyDiscount && (
                                                        <td style={{ fontSize: '0.85em', color: '#999' }}>
                                                            {(() => {
                                                                let names = [];
                                                                if (item.manual_discount > 0) names.push('Manual');
                                                                if (item.applied_discounts && item.applied_discounts.length > 0) {
                                                                    names = names.concat(item.applied_discounts.map(d => d.name));
                                                                }
                                                                return names.length > 0 ? names.join(' + ') : '--';
                                                            })()}
                                                        </td>
                                                    )}
                                                    <td style={{ color: '#555' }}>
                                                        {Globals.formatMiles(parseFloat(regularQty * netOrigPrice).toFixed(decimals))}
                                                    </td>
                                                    <td></td>
                                                </tr>
                                            ) : null;

                                            return [mainRow, extraRow];
                                        })}
                                    </tbody>
                                </table>
                            );
                        })()}
                    </section>
                </div>
            </Menu>
        )
    }
}

const BackButton = ({ onClick }) => (
    <div className="back-button">
        <img src={LeftArrowIcon} onClick={() => onClick()} alt="Regresar" />
    </div>
)

const Totals = ({ totals, isPaymentStep, onSubmit, isSubmittedForm = false, form, onChange, decimals = 2 }) => (
    <div className="totals-wrapper">
        {!!isPaymentStep && (
            <ul className="totals inverted">
                <li>
                    <span>Subtotal</span>
                    <span className="amount">{format(totals.subtotal_bs, decimals)}</span>
                </li>
                <li>
                    <span>Abonado</span>
                    <span className="amount">{format(totals.paid_bs, decimals)}</span>
                </li>
                <li>
                    <span>Restante</span>
                    <span className="amount">{format(totals.left_bs, decimals)}</span>
                </li>
            </ul>
        )}

        <ul className="totals">
            {!isPaymentStep && (
                <li>
                    <span>Subtotal</span>
                    <span className="amount">{format(totals.subtotal_bs, decimals)}</span>
                </li>
            )}

            <li>
                <span>Total ({Globals.getLocalCurrencySymbol(form.user)})</span>
                <div>
                    <div className="amount bold red" style={{ fontSize: 22 }}>
                        {format(totals.total_bs, decimals)}
                    </div>
                    <div className="amount bold green" style={{ fontSize: 18 }}>
                        $ {format(totals.total_usd, decimals)}
                    </div>
                </div>
            </li>

            {!!isPaymentStep && (
                <>
                    <li>
                        <span>Cambio {Globals.getLocalCurrencySymbol(form.user)}</span>
                        <div>
                            <div className="amount" style={{ fontSize: 16 }}>
                                {format(totals.change_bs, decimals)}
                            </div>
                            <div className="amount" style={{ fontSize: 14 }}>
                                $ {format(totals.change_usd, decimals)}
                            </div>
                        </div>
                    </li>
                    <li>
                        <span>Moneda</span>
                        <div>
                            <select
                                value={form.currency}
                                onChange={e => onChange(e.target.value, 'currency')}
                            >
                                <option value={Constants.CURRENCIES.DOLARES} selected>$ (USD)</option>
                                <option value={Constants.CURRENCIES.BOLIVARES}>{Globals.getLocalCurrencySymbol(form.user)} ({Globals.getLocalCurrencyName(form.user)})</option>
                            </select>
                        </div>
                    </li>
                    <li>
                        <Button
                            color="green"
                            block
                            onClick={() => onSubmit()}
                            disabled={isSubmittedForm}
                        >
                            {isSubmittedForm
                                ? <Spinner animation="border" size="sm" role="status" />
                                : <span>FINALIZAR PEDIDO</span>
                            }
                        </Button>
                    </li>
                </>
            )}
        </ul>
    </div>
);

const PaymentItem = ({ item, index, onChange, onRemove, decimals = 2 }) => {

    const [bsHasChaged, setBsHasChaged] = useState(false);

    return (
        <tr key={`payment-${index}`}>
            <td>{item.name}</td>
            <td>
                <NumberFormat
                    value={item.amount}
                    allowNegative={false}
                    decimalScale={decimals} // Ajustado a decimales dinámicos
                    onFocus={() => setBsHasChaged(false)}
                    onValueChange={v => !bsHasChaged && onChange(v.value)}
                />
            </td>
            <td>
                {item.isLocalCurrency ? (
                    <NumberFormat
                        value={item.amount_bs}
                        allowNegative={false}
                        decimalScale={decimals} // Ajustado a decimales dinámicos
                        onFocus={() => setBsHasChaged(true)}
                        onValueChange={v => bsHasChaged && onChange(v.value, true)}
                    />
                ) : (
                    format(parse(Number(item.amount_bs), decimals), decimals)
                )}
            </td>
            <td>
                <img
                    src={CloseIcon}
                    className="btn-remove"
                    title="Remover método de pago"
                    alt="Remover método de pago"
                    onClick={() => onRemove()}
                />
            </td>
        </tr>
    )
}

export default connect(state => ({
    user: state.user,
    currency: state.currency,
}))(NewRequest)